import { makeStyles } from "@material-ui/core";
import { hexToRGB } from "src/util";

export const useStyles = makeStyles((theme) => ({
  chip: {
    alignItems: "center",
    background: `rgba(${hexToRGB(theme.palette.secondary.main)}, 0.1)`,
    borderRadius: "4px",
    color: theme.palette.text.primary,
    display: "flex",
    gridGap: "0.75rem",
    padding: "8px",
  },
  label: {
    fontSize: 12,
  },
}));



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/sport-table/components/survey-link/styles.ts